module.exports = __webpack_public_path__ + "img/legacy_4.ab2e09ff.jpg";